"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayMonitoringHardwareDto = void 0;
class DisplayMonitoringHardwareDto {
    battery;
    blockDevices;
    bluetoothDevices;
    cpu;
    cpuTemperature;
    currentLoad;
    disksIO;
    diskUsage;
    displayId;
    fsStats;
    fullLoad;
    graphics;
    inetChecksite;
    inetLatency;
    memory;
    networkConnections;
    networkGatewayDefault;
    networkInterfaceDefault;
    networkInterfaces;
    networkStats;
    os;
    osInfo;
    processes;
    services;
    system;
    time;
    timestamp;
    users;
    uuid;
    versions;
    wifiConnections;
    wifiNetworks;
}
exports.DisplayMonitoringHardwareDto = DisplayMonitoringHardwareDto;
